// extracted by mini-css-extract-plugin
module.exports = {"card":"Login_card__1ZDvk","titleStyle":"Login_titleStyle__bhbB4","linkStyle":"Login_linkStyle__1WdG0"};